export interface VideoItem {
  id: string;
  slug: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  date: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    slug: '91-video-hot-recommend-001',
    title: '2026年度热门影视精选合辑 | 91视频倾情推荐',
    category: '91-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20digital%20video%20platform%20interface%20with%20warm%20golden%20accents%2C%20cinematic%20film%20reel%20and%20play%20button%20on%20dark%20background%2C%20professional%20video%20streaming%20aesthetic%2C%20clean%20minimal%20design%20with%20soft%20lighting&width=640&height=360&seq=v001-thumb&orientation=landscape',
    duration: '45:30',
    views: 1285600,
    rating: 9.2,
    date: '2026-07-28',
    description: '精心挑选2026年度最受欢迎的高清影视作品，涵盖动作、喜剧、悬疑等多种类型，为您打造极致的观影体验。每一部作品都经过专业团队筛选，确保画质与内容的双重品质保障。',
    tags: ['热门推荐', '高清影视', '2026新片', '精选合辑'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v002',
    slug: '97-video-classic-movie-002',
    title: '经典老片修复版 | 97视频高清重制系列',
    category: '97-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20movie%20poster%20style%20with%20warm%20nostalgic%20tones%2C%20golden%20film%20grain%20texture%2C%20retro%20cinema%20aesthetic%2C%20elegant%20typography%20on%20dark%20background&width=640&height=360&seq=v002-thumb&orientation=landscape',
    duration: '120:00',
    views: 895300,
    rating: 9.5,
    date: '2026-07-25',
    description: '重温那些年我们追过的经典影片，97视频团队采用最新AI修复技术，将经典老片进行高清重制，让您在大屏幕上重新感受那些难忘的光影时刻。',
    tags: ['经典修复', '高清重制', '怀旧经典', '老片新看'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v003',
    slug: '51-video-documentary-003',
    title: '探索未知世界 | 51视频自然纪录片特辑',
    category: '51-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20golden%20sunlight%20through%20forest%20canopy%2C%20wildlife%20silhouette%2C%20cinematic%20photography%20style%2C%20warm%20earthy%20tones&width=640&height=360&seq=v003-thumb&orientation=landscape',
    duration: '58:20',
    views: 672100,
    rating: 9.0,
    date: '2026-07-22',
    description: '跟随51视频的镜头，走进地球上最神秘的自然角落。从深海到高山，从极地到热带雨林，我们为您呈现最震撼的自然纪录片体验。',
    tags: ['纪录片', '自然探索', '高清摄影', '科普教育'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v004',
    slug: 'jiujiu-video-variety-show-004',
    title: '欢乐无限 | 久久视频综艺娱乐大放送',
    category: 'jiujiu-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20warm%20spotlights%2C%20entertainment%20studio%20set%2C%20vibrant%20but%20elegant%20color%20scheme%20with%20golden%20accents%2C%20professional%20broadcast%20style&width=640&height=360&seq=v004-thumb&orientation=landscape',
    duration: '90:00',
    views: 1567800,
    rating: 8.8,
    date: '2026-07-20',
    description: '久久视频为您带来最欢乐的综艺娱乐内容，搞笑段子、才艺比拼、明星访谈，让您在繁忙的生活中找到片刻轻松与欢笑。',
    tags: ['综艺娱乐', '搞笑节目', '明星访谈', '才艺秀'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v005',
    slug: 'digital-video-tech-review-005',
    title: '2026数码产品深度评测 | 数字视频大全科技频道',
    category: 'digital-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20tech%20gadgets%20on%20minimal%20desk%20setup%20with%20warm%20ambient%20lighting%2C%20sleek%20device%20product%20photography%2C%20clean%20professional%20aesthetic%20with%20golden%20highlights&width=640&height=360&seq=v005-thumb&orientation=landscape',
    duration: '35:15',
    views: 423800,
    rating: 8.6,
    date: '2026-07-18',
    description: '数字视频大全科技频道带来最新数码产品的深度评测，从手机到笔记本，从智能家居到可穿戴设备，专业视角为您解析每一款产品的亮点与不足。',
    tags: ['科技评测', '数码产品', '2026新品', '深度解析'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v006',
    slug: '91-video-anime-collection-006',
    title: '热血动漫合集 | 91视频动漫频道精选',
    category: '91-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20vibrant%20warm%20colors%2C%20dynamic%20action%20scene%20silhouette%2C%20Japanese%20animation%20aesthetic%20with%20golden%20energy%20effects%2C%20cinematic%20composition&width=640&height=360&seq=v006-thumb&orientation=landscape',
    duration: '250:00',
    views: 2345600,
    rating: 9.4,
    date: '2026-07-15',
    description: '91视频动漫频道为您精选最热血的动漫作品合集，从经典番剧到最新连载，一站式满足动漫爱好者的所有需求。高清画质、中文字幕，让您沉浸其中。',
    tags: ['动漫合集', '热血番', '经典动漫', '新番推荐'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v007',
    slug: '97-video-food-travel-007',
    title: '舌尖上的旅行 | 97视频美食纪录片系列',
    category: '97-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20cuisine%20food%20photography%20with%20warm%20golden%20lighting%2C%20steaming%20dishes%20on%20wooden%20table%2C%20rustic%20elegant%20dining%20scene%2C%20professional%20food%20styling&width=640&height=360&seq=v007-thumb&orientation=landscape',
    duration: '60:45',
    views: 987200,
    rating: 9.1,
    date: '2026-07-12',
    description: '跟随97视频的镜头，走遍中国大江南北，探寻各地特色美食的制作工艺与文化底蕴。每一道菜都是一个故事，每一口都是文化的传承。',
    tags: ['美食记录', '旅行美食', '地方特色', '饮食文化'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v008',
    slug: '51-video-sports-highlights-008',
    title: '精彩赛事回顾 | 51视频体育频道集锦',
    category: '51-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20action%20moment%20with%20dramatic%20lighting%2C%20athlete%20in%20motion%20on%20field%2C%20stadium%20atmosphere%2C%20warm%20golden%20hour%20sports%20photography%20style&width=640&height=360&seq=v008-thumb&orientation=landscape',
    duration: '30:00',
    views: 756400,
    rating: 8.7,
    date: '2026-07-10',
    description: '51视频体育频道为您带来最精彩的赛事回顾，足球、篮球、网球、赛车等各类体育赛事的精华集锦，不错过每一个激动人心的瞬间。',
    tags: ['体育赛事', '精彩集锦', '足球', '篮球'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v009',
    slug: 'jiujiu-video-education-009',
    title: '终身学习 | 久久视频在线教育精选课程',
    category: 'jiujiu-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20online%20education%20scene%20with%20warm%20lighting%2C%20laptop%20and%20notebooks%20on%20wooden%20desk%2C%20clean%20organized%20study%20space%2C%20professional%20learning%20environment%20aesthetic&width=640&height=360&seq=v009-thumb&orientation=landscape',
    duration: '180:00',
    views: 345600,
    rating: 9.0,
    date: '2026-07-08',
    description: '久久视频教育频道汇集优质在线课程资源，涵盖编程、设计、语言、职场技能等多个领域，帮助您在碎片化时间中持续成长。',
    tags: ['在线教育', '技能学习', '职业成长', '知识付费'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v010',
    slug: 'digital-video-music-live-010',
    title: '音乐现场 | 数字视频大全演唱会实况',
    category: 'digital-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20dramatic%20warm%20spotlights%2C%20live%20performance%20atmosphere%2C%20crowd%20silhouettes%2C%20professional%20concert%20photography%20with%20golden%20lighting&width=640&height=360&seq=v010-thumb&orientation=landscape',
    duration: '120:30',
    views: 1892300,
    rating: 9.3,
    date: '2026-07-05',
    description: '数字视频大全为您收录最震撼的音乐现场演出实况，从华语经典到国际巨星，高清音质还原，让您如同亲临演唱会现场。',
    tags: ['音乐现场', '演唱会', '华语音乐', '国际巨星'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v011',
    slug: '91-video-drama-series-011',
    title: '热门剧集追更指南 | 91视频电视剧频道',
    category: '91-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20series%20scene%20with%20warm%20cinematic%20lighting%2C%20actors%20silhouette%20in%20emotional%20moment%2C%20professional%20film%20production%20aesthetic%2C%20golden%20color%20grading&width=640&height=360&seq=v011-thumb&orientation=landscape',
    duration: '45:00',
    views: 2104500,
    rating: 8.9,
    date: '2026-07-03',
    description: '91视频电视剧频道为您整理当下最热门的电视剧追更指南，都市情感、古装权谋、悬疑探案，各类剧集一网打尽。',
    tags: ['热门剧集', '电视剧', '追剧指南', '国产剧'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v012',
    slug: '97-video-game-live-012',
    title: '游戏实况解说 | 97视频游戏频道精选',
    category: '97-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20RGB%20lighting%20and%20warm%20accents%2C%20professional%20streaming%20desk%2C%20gaming%20peripherals%2C%20modern%20esports%20aesthetic%20with%20clean%20composition&width=640&height=360&seq=v012-thumb&orientation=landscape',
    duration: '55:20',
    views: 876300,
    rating: 8.5,
    date: '2026-06-30',
    description: '97视频游戏频道带来最专业的游戏实况解说，从3A大作到独立精品，从速通挑战到剧情解析，满足每一位游戏玩家的需求。',
    tags: ['游戏实况', '游戏解说', '3A大作', '电竞'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'v013',
    slug: '51-video-travel-vlog-013',
    title: '环球旅行日记 | 51视频旅游Vlog系列',
    category: '51-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20travel%20destination%20landscape%20with%20warm%20sunset%20lighting%2C%20scenic%20nature%20view%2C%20travel%20photography%20aesthetic%2C%20golden%20hour%20atmosphere%20with%20mountains&width=640&height=360&seq=v013-thumb&orientation=landscape',
    duration: '40:15',
    views: 654200,
    rating: 8.8,
    date: '2026-06-28',
    description: '跟随51视频旅游博主的脚步，走遍世界各地，探索异国风情。真实的旅行体验分享，实用的旅行攻略，让您的下一次出行更加精彩。',
    tags: ['旅行Vlog', '环球旅行', '旅游攻略', '异国风情'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v014',
    slug: 'jiujiu-video-kids-content-014',
    title: '亲子时光 | 久久视频儿童教育动画合集',
    category: 'jiujiu-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20children%20educational%20content%20with%20warm%20soft%20lighting%2C%20cute%20animated%20characters%2C%20playful%20learning%20environment%2C%20gentle%20pastel%20colors%20with%20golden%20accents&width=640&height=360&seq=v014-thumb&orientation=landscape',
    duration: '200:00',
    views: 1234000,
    rating: 9.1,
    date: '2026-06-25',
    description: '久久视频为小朋友们精心挑选寓教于乐的优质动画内容，涵盖语言启蒙、科学探索、艺术培养等多个方面，让学习变得有趣。',
    tags: ['儿童教育', '亲子动画', '启蒙教育', '寓教于乐'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v015',
    slug: 'digital-video-fitness-guide-015',
    title: '居家健身指南 | 数字视频大全运动频道',
    category: 'digital-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Home%20fitness%20workout%20scene%20with%20warm%20morning%20light%2C%20yoga%20mat%20and%20dumbbells%20in%20minimal%20living%20room%2C%20healthy%20lifestyle%20aesthetic%2C%20clean%20and%20motivating%20atmosphere&width=640&height=360&seq=v015-thumb&orientation=landscape',
    duration: '25:30',
    views: 432100,
    rating: 8.4,
    date: '2026-06-22',
    description: '数字视频大全运动频道推出居家健身指南系列，无需器械也能高效锻炼。专业教练在线指导，科学训练方案，助您塑造健康体魄。',
    tags: ['居家健身', '运动教程', '健康生活', '瑜伽'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'v016',
    slug: '91-video-movie-review-016',
    title: '深度影评 | 91视频电影解析专栏',
    category: '91-video',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20analysis%20scene%20with%20warm%20theater%20lighting%2C%20movie%20projector%20and%20film%20strips%2C%20intellectual%20film%20criticism%20aesthetic%2C%20dark%20academia%20style&width=640&height=360&seq=v016-thumb&orientation=landscape',
    duration: '32:00',
    views: 287600,
    rating: 9.0,
    date: '2026-06-20',
    description: '91视频电影解析专栏为您提供专业的深度影评，从剧情分析到镜头语言，从角色塑造到主题探讨，全方位解读每一部值得一看的电影。',
    tags: ['深度影评', '电影解析', '专业点评', '观影指南'],
    isHot: false,
    isNew: false,
  },
];